<template>
  <div>
    <div class="header-space">
      <modal
        name="dialog"
        draggable
        :pivotX="0.3"
        :pivotY="0.3"
        height="400px"
        width="300px"
      >
        <v-card
          tile
          elevation="0"
        >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  @click="hideModal"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>더 이상 안보이기</span>
            </v-tooltip>
          </v-card-actions>
          <v-img
            :src="popupImg[0]"
            cover
          ></v-img>
        </v-card>
      </modal>
    </div>
    <section id="banner">
      <swiper :options="swiperOption">
        <swiper-slide
          v-for="(item,i) in bannerList.filter(b => b.isActive)"
          :key="i"
        >
          <v-img
            :src="`/images/${item.imgFileName}`"
            cover
            :style="{height: item.height}"
          ></v-img>
          <!-- <img
            :src="item.src"
            cover
            :style="{height: item.height, objectFit: 'cover'}"
          /> -->
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
    </section>

    <!--
    <section id="pin-slider">
      <section id="slider-container">
        <section id="brand-section">
          <div class="section-cover">
            <ul class="menu">
              <li>BRUNCH</li>
              <li>COFFEE</li>
              <li>BAKERY</li>
            </ul>
            <div class="main-copy">
              <div class="line">
                <hr align="center" />
              </div>
              <h1>By Chefs Touch</h1>
              <div class="line">
                <hr align="center" />
              </div>
            </div>
            <div class="main-desc">
              <div></div>
              <div></div>
              <div class="content">
                <p class="desc">
                  더브라운은 소중한 고객에게 내어드릴<br />
                  베이커리와 커피 & 브런치를 준비하기 위해 어제보다<br />
                  더 분주한 '오늘'을 보냅니다.
                </p>
              </div>
              <div></div>
            </div>
          </div>
        </section>
        <section id="salt-section">
          <div class="section-cover">
            <div class="salt-spacer mobile-none"></div>
            <div class="main-copy">
              <div class="line">
                <hr align="center" />
              </div>
              <h1>Make From Nature</h1>
              <div class="line">
                <hr align="center" />
              </div>
            </div>
            <div class="main-desc salt">
              <div></div>
              <div></div>
              <div class="content">
                <p class="desc">
                  더 브라운은 자연에서 효모균을 <br />
                  모아 만든 발효종만을 사용합니다
                </p>
              </div>
              <div></div>
            </div>
            <div class="main-desc-more mobile-none">
              <div></div>
              <div class="desc-contents">
                <img :src="require('../assets/images/salt-thumb.png')" />
                <div>
                  <h2>프랑스 게랑드 염전</h2>
                  <p>게랑드 소금은 자연으로 추출되는 소금으로 고가지만<br />
                    섬세한 맛을 구현하여 전세계 쉐프와 파티시에들이<br />
                    가장 선호하는 소금 중 하나입니다.
                  </p>
                </div>
              </div>
              <div class="desc-contents">
                <img :src="require('../assets/images/salt-thumb-2.png')" />
                <div>
                  <h2>천연발효종 과정</h2>
                  <p>더 브라운만이 제공하는 천연 발효종 과정을 통해<br />
                    저온 숙성빵을 만들어냅니다.<br />
                  </p>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </section>
      </section>
    </section> -->
    <section id="menu-section">
      <div class="section-contents">
        <div class="section-title">
          <h2 class="main-title flex-contents">
            MENU
            <span>더브라운 메뉴</span>
          </h2>
          <div class="spacer"></div>
          <div class="subtitle flex-contents">
            <p
              id="menuSubtitle"
              class="gsapSubtitle"
            >
              <!-- <span style="font-weight: 300">싱그러운 재료와 정성을</span><br/>
              <span style="font-weight: 400">싱그러운 재료와 정성을</span><br/>
              <span style="font-weight: 700">싱그러운 재료와 정성을</span><br/>
              <span style="font-weight: 900">싱그러운 재료와 정성을</span><br/> -->
              직접 선별한 원두로 내린 커피와 천연 발효종을 이용한 베이커리, 싱그러운 재료와 정성을 아낌없이 담아낸 브런치!<br />
              더 브라운만의 메뉴를 소개합니다.
            </p>
          </div>
          <div class="spacer"></div>
          <div class="flex-1 flex-contents">
            <router-link
              class="detailBtn"
              to="/menu/bakery"
            >더 많은 메뉴 보기</router-link>
          </div>
        </div>
        <div class="section-content main-menus">
          <div class="main-menu flex-contents">
            <p class="en-name">
              brunch &<br />
              food
            </p>
            <p class="ko-name">
              브런치와<br />
              푸드
            </p>
            <router-link to="/menu/brunch">
              <img src="images/main-menu-brunch.png" />
            </router-link>
          </div>
          <div class="spacer"></div>
          <div class="main-menu flex-contents">
            <p class="en-name">
              coffee &<br />
              drink
            </p>
            <p class="ko-name">커피와 음료<br /><br /></p>
            <router-link to="/menu/coffee">
              <img src="images/main-menu-coffee.png" />
            </router-link>
          </div>
          <div class="spacer"></div>
          <div class="main-menu flex-contents">
            <p class="en-name">
              bakery &<br />
              cake
            </p>
            <p class="ko-name">
              베이커리와<br />
              케이크
            </p>
            <router-link to="/menu/bakery">
              <img src="images/main-menu-cake.png" />
            </router-link>
          </div>
        </div>
        <div class="section-content push-menu">
          <!-- <p>
            이달의<br />
            추천메뉴
          </p>
          <img
            src="images/choice_menu.png"
            class="recommendedMenu"
          />
          <span class="menu-name">블랙슈거 & 넛츠빙수</span> -->
        </div>
      </div>
    </section>
    <section id="store-section">
      <div class="section-contents">
        <div class="section-title">
          <h2 class="main-title flex-contents">
            STORE
            <span>더브라운 매장</span>
          </h2>
          <div class="spacer"></div>
          <div class="subtitle flex-contents">
            <p
              id="storeSubtitle"
              class="gsapSubtitle"
            >
              더브라운은 누구에게나 따뜻하고 친숙한 공간을 내어드립니다.<br />
              함께 소통하며 오랫동안 더브라운만의 이야기를 만들어가고 싶습니다.
            </p>
          </div>
          <div class="spacer"></div>
          <div class="flex-1 flex-contents">
            <a class="detailBtn txt-white">전체 스토어 보기</a>
          </div>
        </div>
        <div class="section-content">
          <div class="store-CS flex-contents">
            <div class="store-count">
              <div class="land">
                <p>전국</p>
                <span></span>
              </div>
              <ICountUp
                class="count-up count"
                :delay="countDelay"
                :endVal="getStoreCount"
                :options="options"
                ref="storeCounter"
              />
              <!-- <span
                id="store_count"
                class="count-up count"
              >31</span> -->
              <div class="description">
                <p>개 매장에서</p>
                <span>가장 맛있는 브런치와 커피를 준비하는 더브라운입니다.</span>
              </div>
            </div>
            <div class="store-slider">
              <p>대표매장</p>
              <div class="slider">
                <!-- <div
                  class="arrow left dark"
                  slot="button-prev"
                ></div> -->
                <swiper :options="swiperOption">
                  <swiper-slide
                    v-for="(item,i) in getRecommendedStore"
                    :key="i"
                  >
                    <v-img
                      class="slider-content"
                      :src="'/images/store/'+ item.imgSrc"
                      cover
                      @click="clickRecommendedStore(item.nameO)"
                    ></v-img>
                    <span>{{item.name}}</span>
                  </swiper-slide>
                  <div
                    class="swiper-pagination swiper-pagination-white"
                    style="transform: translateY(-20px)"
                    slot="pagination"
                  ></div>
                  <!-- <div
                    class="swiper-button-prev swiper-button-white"
                    slot="button-prev"
                  ></div>
                  <div
                    class="swiper-button-next swiper-button-white"
                    slot="button-next"
                  ></div> -->

                </swiper>
                <!-- <div
                  class="arrow right dark"
                  slot="button-next"
                ></div> -->
              </div>
            </div>
          </div>
          <div class="spacer"></div>
          <div class="store-mapchart flex-contents">
            <!-- 이곳에 차트를 넣으시면 됩니다 <img> 주석처리 or 삭제 부탁드립니다. -->
            <div class="map">
              <div
                id="pt-ICN"
                class="wrap"
                style="top:75px; left:-75px; "
                @mouseover="countUp('icn')"
              >
                <div class="icon"></div>
                <div class="map-info">
                  <p>
                    <ICountUp
                      class="count-up count"
                      :delay="countDelay + 1000"
                      :endVal="[].length"
                      :options="options"
                      ref="icn"
                    />EA</p>
                  <h3>인천광역시</h3>
                </div>
              </div>
              <div
                id="pt-SEO"
                class="wrap"
                style="top:40px; left:-34px;"
                @mouseover="countUp('seoul')"
              >
                <div class="icon"></div>
                <div class="map-info">
                  <p>
                    <ICountUp
                      class="count-up count"
                      :delay="countDelay + 1000"
                      :endVal="[].length"
                      :options="options"
                      ref="seoul"
                    />EA</p>
                  <h3>서울특별시</h3>
                </div>
              </div>
              <div
                id="pt-GGD"
                class="wrap"
                style="top:100px; left:-30px;"
                @mouseover="countUp('ggd')"
              >
                <div class="icon"></div>
                <div class="map-info">
                  <p>
                    <ICountUp
                      class="count-up count"
                      :delay="countDelay + 1000"
                      :endVal="[].length"
                      :options="options"
                      ref="ggd"
                    />EA</p>
                  <h3>경기도</h3>
                </div>
              </div>

              <div
                id="pt-GWD"
                class="wrap"
                style="top:69px; left:50px;"
              >
                <div class="icon disable"></div>
              </div>
              <div
                id="pt-CND"
                class="wrap"
                style="top:140px; left:-40px;"
              >
                <div class="icon disable"></div>
                <!-- <div class="map-info">
                  <p><span>2</span>EA</p>
                  <h3>충청남도</h3>
                </div> -->
              </div>
              <div
                id="pt-CBD"
                class="wrap"
                style="top:121px; left:8px;"
              >
                <div class="icon disable"></div>
              </div>
              <div
                id="pt-GBD"
                class="wrap"
                style="top:170px; left:54px;"
                @mouseover="countUp('daegu')"
              >
                <div class="icon"></div>
                <div class="map-info right">
                  <p>
                    <ICountUp
                      class="count-up count"
                      :delay="countDelay + 1000"
                      :endVal="[].length"
                      :options="options"
                      ref="daegu"
                    />EA</p>
                  <h3>대구광역시</h3>
                </div>
              </div>
              <div
                id="pt-JBD"
                class="wrap"
                style="top:227px; left:-20px;"
              >
                <div class="icon disable"></div>
              </div>
              <div
                id="pt-GND"
                class="wrap"
                style="top:220px; left:90px;"
                @mouseover="countUp('ulsan')"
              >
                <div class="icon"></div>
                <div class="map-info right">
                  <p>
                    <ICountUp
                      class="count-up count"
                      :delay="countDelay + 1000"
                      :endVal="[].length"
                      :options="options"
                      ref="ulsan"
                    />EA</p>
                  <h3>울산광역시</h3>
                </div>
              </div>
              <div
                id="pt-BSN"
                class="wrap"
                style="top:270px; left:90px;"
                @mouseover="countUp('busan')"
              >
                <div class="icon"></div>
                <div class="map-info right">
                  <p>
                    <ICountUp
                      class="count-up count"
                      :delay="countDelay + 1000"
                      :endVal="[].length"
                      :options="options"
                      ref="busan"
                    />EA</p>
                  <h3>부산광역시</h3>
                </div>
              </div>
              <div
                id="pt-GNJ"
                class="wrap"
                style="top:270px; left:-60px;"
              >
                <div class="icon disable"></div>
                <!-- <div class="map-info">
                  <p><span>2</span>EA</p>
                  <h3>광주광역시</h3>
                </div> -->
              </div>
            </div>
          </div>
          <div class="spacer"></div>
          <div class="store-inputs flex-contents">
            <p>가장 가까운 더브라운 매장을 검색해보세요.</p>
            <div style="margin-top: 20px;">
              <v-text-field
                hint="매장명을 입력하세요"
                color="white"
                dark
                outline
                single-line
                v-model="inputStoreName"
                @keyup.enter="searchStore()"
              >
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <img
                      class="search-btn"
                      width="24px"
                      height="24px"
                      :src="require('../assets/images/store-map-default.svg')"
                      alt=""
                      @click="searchStore()"
                    >
                  </v-fade-transition>
                </template></v-text-field>
              <!-- <v-select
                dark
                :items="['서울특별시', '경기도', '인천광역시', '부산광역시', '울산광역시' , '대구광역시']"
              ></v-select> -->
              <!-- <v-btn
                class="search-btn"
                color="primary"
                depressed
                @click="searchStore()"
              >
                <v-icon>search</v-icon>
              </v-btn> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="community-section">
      <div class="section-contents">
        <div class="section-title ">
          <h2 class="main-title flex-contents">
            COMMUNITY
            <span>더브라운 커뮤니티</span>
          </h2>
          <div class="spacer"></div>
          <div class="subtitle flex-contents">
            <p
              id="communitySubtitle"
              class="gsapSubtitle"
            >
              더브라운의 즐겁고 행복한 일상을 공유합니다</p>
          </div>
          <div class="spacer"></div>
          <div class="column news flex-contents">
            <div class="news-title">
              <h3>NEWS</h3>
              <div class="arrow right"></div>
            </div>
            <div class="body">
              <div
                class="row"
                v-for="item in newsList.slice(0,6)"
                :key=item.id
              >
                <router-link :to="'/community/'+item.id">
                  <p>{{(item.text.length > 25) ? item.text.slice(0,22) + '...' : item.text}}</p>
                  <span>{{item.update.substring(0,10)}}</span>
                </router-link>
              </div>
            </div>
            <div class="footer">
              <h3>
                <router-link to="/community">뉴스 전체보기 </router-link>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// require styles
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'

import ICountUp from 'vue-countup-v2'
import axios from 'axios'
import _ from 'lodash'
import debounce from 'lodash/debounce';
import { TweenMax, TimelineMax } from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin.js'
import DialogDrag from 'vue-dialog-drag'
export default {
  name: 'landing',
  components: {
    ICountUp,
    swiper,
    swiperSlide,
    DialogDrag,
  },
  created () {
    this.$nextTick(async () => {
      this.newsList = await axios.get(document.api_host + '/news.json')
        .then(({ data }) => {
          return _.orderBy(data, ['update'],['desc'])
        })
        .catch(err => console.error('no data ( data fetch error )'))
      this.storeList = await axios.get(document.api_host + '/stores.json')
        .then(({ data }) => {
          return data
        })
        .catch(err => console.error('no data ( data fetch error )'))
      this.bannerList = await axios.get(document.api_host + '/banners.json')
        .then(({ data }) => {
          return _.sortBy(data, ['seq'])
        })
        .catch(err => console.error('no data ( data fetch error )'))
      this.popupList = await axios.get(document.api_host + '/popups.json')
        .then(({ data }) => {
          this.popupImg = data.filter(p => p.isActive).map(p => ('/images/' + p.imgFileName))
          return _.sortBy(data.filter(p => p.isActive), ['seq'])
        })
        .catch(err => console.error('no data ( data fetch error )'))

      //팝업 불러오는 코드
      !document.isPopped && this.popupList.length > 0 && this.$modal.show('dialog', {
        title: 'Alert!',
        text: 'You are too awesome',
        buttons: [
          {
            title: 'Deal with it',
            handler: () => { alert('Woot!') }
          },
          {
            title: '',       // Button title
            default: true,    // Will be triggered by default if 'Enter' pressed.
            handler: () => { } // Button click handler
          },
          {
            title: 'Close'
          }
        ]
      })

    })
    this.handleDebouncedScroll = debounce(this.handleScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted () {
    // console.log(this.popupList)

    // const scene = this.$scrollmagic.scene()
    // const controller = this.$scrollmagic.controller()

    // console.console(scene, controller)
    // const wipeAnimation = new TimelineMax()
    //   // .from('#brand-section', 2, { opacity: 0, ease: Power1.easeIn })
    //   .from('#brand-section .main-copy', 1.5, { scale: 0.9, opacity: 0 })
    //   // .to('#brand-section', 2, { opacity: 0, scale: 1.3, delay: 5 })
    //   // // .to("#slider-container", 1, { z: -150, delay: 3 })		// move back in 3D space
    //   .to("#slider-container", 1, { x: "-50%", delay: 5, ease: Power1.easeIn })	// move in to first panel
    //   // // .to("#slider-container", 1, { z: 0 })
    //   // // // .from('#salt-section', 3, { opacity: 0, scale: 1.3, ease: Power1.easeIn })
    //   .from('#salt-section .main-copy h1', 1.5, { opacity: 0, scale: 0.9, delay: 1 })
    //   .from('#salt-section .desc-contents img', 1, { opacity: 0, x: -30 })
    //   .from('#salt-section .desc-contents div', 1, { opacity: 0, y: 30, delay: 0 })
    //   .to({}, 5, {})
    //   .repeat(-1).yoyo(true)

    // Declare Scene

    const menuSubtitleScene = this.$scrollmagic.scene({
      // ID of element where animation starts
      triggerElement: '#menuSubtitle',
      // {0,0.5,1} - animations starts from {top,center,end} of window
      triggerHook: 1,
      // Duration of animation
      duration: 200
    })
      // Declaration of animation and attaching to element
      .setTween(new TweenMax.from('#menuSubtitle', 1, { x: 100, opacity: 0 }))
    // .addIndicators({ name: 'menu (duration: 200)' })
    const storeSubtitleScene = this.$scrollmagic.scene({
      // ID of element where animation starts
      triggerElement: '#storeSubtitle',
      // {0,0.5,1} - animations starts from {top,center,end} of window
      triggerHook: 0.5,
      // Duration of animation
      duration: 200
    })
      // Declaration of animation and attaching to element
      .setTween(new TweenMax.from('#storeSubtitle', 1, { x: -50, opacity: 0 }))
    // .addIndicators({ name: 'store (duration: 300)' })

    const communitySubtitleScene = this.$scrollmagic.scene({
      // ID of element where animation starts
      triggerElement: '#community-section',
      // {0,0.5,1} - animations starts from {top,center,end} of window
      triggerHook: 0.5,
      // Duration of animation
      duration: 100
    })
      // Declaration of animation and attaching to element
      .setTween(new TweenMax.from('#communitySubtitle', 1, { y: 0, opacity: 1 }))
    // .addIndicators({ name: 'community (duration: 300)' })
    this.$scrollmagic.addScene(menuSubtitleScene)
    this.$scrollmagic.addScene(storeSubtitleScene)
    // this.$scrollmagic.addScene(communitySubtitleScene)
    // Helpful tags for orientation on the screen
    // .addIndicators({ name: '2 (duration: 300)' })

    // Add Scene to controller
  },
  methods: {
    hideModal () {
      this.$modal.hide('dialog')
      document.isPopped = true
      console.log(document.isPopped)
    },
    hasScrolled (p) {
      // console.log(p)
      if (p > 560) {
        if (!this.didCountUp) {
          // var demo = new CountUp('store_count', 31)
          if (this.$refs.storeCounter) {
            this.$refs.storeCounter.reset()
            this.$refs.storeCounter.update(this.storeList.length)
            this.didCountUp = !this.didCountUp
          }
          // var seoul = new CountUp(document.querySelector('#seo-cnt'), 8)
        }
      } else {
        if (this.didCountUp) {
          this.didCountUp = !this.didCountUp
        }
      }
    },
    handleScroll (event) {
      this.last_known_scroll_position = window.scrollY
      if (!this.ticking) {
        const that = this
        window.requestAnimationFrame(function () {
          that.hasScrolled(that.last_known_scroll_position)
          that.ticking = false
        })
        this.ticking = true
      }
    },
    clickRecommendedStore (name) {
      this.$router.push({
        path: 'store', query: { name: name }
      })
    },
    searchStore () {
      if (this.inputStoreName.length > 1) {
        this.$router.push({
          path: 'store', query: { name: this.inputStoreName }
        })
      }
    },
    countUp (arg) {
      console.log(arg)
      if (arg === 'seoul') {
        this.$refs.seoul.reset()
        this.$refs.seoul.update(this.storeList.filter(s => s.city === '서울').length)
      }
      if (arg === 'icn') {
        this.$refs.icn.reset()
        this.$refs.icn.update(this.storeList.filter(s => s.city === '인천').length)
      }
      if (arg === 'ggd') {
        this.$refs.ggd.reset()
        this.$refs.ggd.update(this.storeList.filter(s => s.city === '경기').length)
      }
      if (arg === 'daegu') {
        this.$refs.daegu.reset()
        this.$refs.daegu.update(this.storeList.filter(s => s.city === '대구').length)
      }
      if (arg === 'ulsan') {
        this.$refs.ulsan.reset()
        this.$refs.ulsan.update(this.storeList.filter(s => s.city === '울산').length)
      }
      if (arg === 'busan') {
        this.$refs.busan.reset()
        this.$refs.busan.update(this.storeList.filter(s => s.city === '부산').length)
      }
    }
  },
  computed: {
    getRecommendedStore () {
      return this.storeList.filter(store => store.isRecommendedStore).map(store => ({ name: store.name, imgSrc: store.storeImage.length > 0 ? store.storeImage[0] : '' }))
    },
    getStoreCount () {
      return this.storeList.length
    },
    getStoreSeoulCount () {
      return this.storeList.filter(t => t.city === '서울').length
    }
  },
  data () {
    return {
      modalKey: 0,
      popupList: [],
      popupImg: [],
      bannerList: [],
      swiperOptionStore: {
        // effect: 'fade',
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      swiperOption: {
        // effect: 'flip',
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        // loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      last_known_scroll_position: 0,
      ticking: false,
      didCountUp: false,
      countDelay: 1000,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      },
      inputStoreName: '',
      storeList: [],
      newsList: []
    }
  },
}
</script>
<style lang="css" scoped>
/*----- from Vue dialog drag -----*/
.dialog-drag {
  z-index: 999;
  min-width: 10em;
  background-color: #e6eee9;
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.5);
}
.dialog-1.dialog-drag {
  border: #1aad8d dashed 2px;
  background-color: #fff;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
}
.dialog-1.dialog-drag .dialog-header {
  background-color: transparent;
}
.dialog-1.dialog-drag .dialog-header .buttons button {
  color: #1aad8d;
}
.dialog-1.dialog-drag .dialog-header .title {
  display: none;
}
.dialog-drag.dialog-1.fixed {
  border: #1aad8d solid 2px;
}
.dialog-2.dialog-drag {
  border-color: #1aad8d;
}
.dialog-2.dialog-drag .dialog-header {
  background-color: #1aad8d;
  color: #fff;
}
.dialog-2.dialog-drag .dialog-header .buttons button {
  color: #fff;
}
.dialog-3.dialog-drag {
  border: none;
  background-color: #fdfaf1;
  animation-name: dialog-3-anim;
}
.dialog-3.dialog-drag .dialog-header {
  background-color: #e3a826;
  color: #fff;
}
.dialog-3.dialog-drag .dialog-header .buttons button {
  color: #f9edd2;
  text-shadow: none;
}
.dialog-3.dialog-drag .dialog-header .buttons button:hover {
  color: #fff;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
}
.dialog-drag.dialog-3.fixed {
  margin: 2em;
  outline: #1aad8d 2px dashed;
  outline-offset: 0.25em;
}
@-moz-keyframes dialog-3-anim {
  0% {
    opacity: 0;
    transform: scaleX(0.1) scaleX(3);
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes dialog-3-anim {
  0% {
    opacity: 0;
    transform: scaleX(0.1) scaleX(3);
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes dialog-3-anim {
  0% {
    opacity: 0;
    transform: scaleX(0.1) scaleX(3);
  }
  100% {
    opacity: 1;
  }
}
@keyframes dialog-3-anim {
  0% {
    opacity: 0;
    transform: scaleX(0.1) scaleX(3);
  }
  100% {
    opacity: 1;
  }
}

/*      ------------------------- */
#pin-slider {
  display: none;
}

.v-select {
  padding-top: 0px;
}
p {
  margin-bottom: 0px !important;
}

div.section-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
/* #menu-section div.section-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
} */
.spacer {
  flex: 1 0 80px;
  /* margin: 0px 50px; */
  /* background-color: blueviolet; */
  height: 50px;
  min-width: 50px;
}
.flex-contents {
  flex: 1 1 360px;
  margin: 0;
  min-width: 280px;
  max-width: 360px;
}

div.section-title > h2.main-title {
  margin-top: -20px;
  font-family: "europa";
  font-size: 55px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: -1px;
}
div.section-title h2.main-title span {
  font-family: "NanumSquare";
  margin-top: 0px;
  display: block;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 1px;
}
div.section-title .subtitle {
  box-sizing: content-box;
}
div.section-title .subtitle p {
  word-break: keep-all;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0px;
}
div.section-title .detailurl {
  /* flex: 1;
  flex-shrink: 0; */
}
/* section */
/* main1-1 */
div.header-space {
  width: 100%;
  height: 110px;
}

/*gsap animation */
.gsapSubtitle {
  opacity: 1;
}
#pin-slider {
}
#banner div.swiper-container {
  max-width: 1500px;
  margin: auto;
}
#slider-container {
  width: 200%;
  height: 730px;
}
#slider-container section {
  float: left;
  height: 730px;
  width: 50%;

  /* padding-top: 130px; */
  /* margin: auto;
  overflow: hidden;
  max-width: 1500px; */
}
div.section-cover {
  background-repeat: no-repeat;

  /* background-attachment: fixed; */
  height: 730px;
  max-height: 730px;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  padding: 100px 0px 80px 0px;
  justify-content: center;
  align-items: center;
  margin: 0px auto;
  /* max-width: 1500px; */
}
#brand-section .section-cover {
  background-position-x: center;
  background-size: 1600px auto;
  background-image: url("/images/main_cover_full.jpg");
}
#salt-section .section-cover {
  background-position-x: center;
  background-position-y: -120px;
  /* background-size: 1500px auto; */
  background-image: url("/images/main-cover-full-alt.jpg");
}
ul.menu {
  /* background-color: paleturquoise; */
  list-style: none;
  color: #ffffff;
  display: flex;
  justify-content: center;
  /* align-items: flex-start; */
}
.menu li {
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  margin: 0px 5px;
}
.menu li:before {
  display: inline-table;
  content: "|";
  margin-right: 10px;
  font-size: 13px;
}
.menu li:first-child::before {
  content: "";
}

div.main-copy {
  /* background-color: tomato; */
  text-align: center;
  width: 100%;
  padding: 0px 20px;
  display: flex;
  justify-content: center;
  align-content: center;
  color: #ffffff;
  height: 250px;
}
div.line {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0px 60px;
}
.main-copy hr {
  border: 0px;
  height: 6px;
  width: 100%;
  background-color: white;
  /* display: block;
  border: solid white;
  width: 60%;
  margin: auto; */
}
.main-copy h1 {
  flex: 0;
  min-width: 1000px;
  font-family: "nexa-rust-script";
  /* text-shadow: 0 0 2px white; */
  font-size: 160px;
}
#salt-section div.salt-spacer {
  height: 150px;
  width: 100%;
}
#salt-section .main-copy h1 {
  /* text-shadow: 0 0 2px white; */
  font-size: 170px;
  line-height: 80%;
  text-align: left;
}

#salt-section div.main-desc-more {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
}
#salt-section div.main-desc-more > div {
  flex-basis: 10%;
}
#salt-section div.main-desc-more > div.desc-contents {
  flex-basis: 30%;
  display: flex;
  align-items: center;
}
#salt-section div.main-desc-more > div.desc-contents > img {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
#salt-section div.main-desc-more > div.desc-contents h2 {
  font-weight: 600;
  font-size: 20px;
  text-shadow: #333;
}
#salt-section div.main-desc-more > div.desc-contents p {
  line-height: 20px;
  font-weight: 400;
}

div.main-desc {
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  transform: translateY(-50px);
}
.main-desc > div {
  flex: 1;
}
.main-desc > div.content {
  min-width: 370px;
}
.main-desc .desc {
  text-align: right;
  /* max-width: 430px; */
  /* background-color: powderblue; */
  /* margin: -30px auto; */
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -1px;
  font-size: 18px;
  /* padding-left: 500px; */
  flex: 1;
}

div.main-desc.salt .desc {
  text-align: left;
  letter-spacing: 0px;
  font-size: 20px;
}
.vue-typer {
  font-family: nexa-rust-script;
  text-align: center;
  font-size: 13em;
  /* font-size: 1 80px; */
  margin: 10px 0;
}
.vue-typer .custom.char.typed {
  color: white;
}
.vue-typer .custom.caret {
  width: 10px;
  background-color: white;
}

/* .vue-typer {
  height: 100px;
}
.vue-typer .custom.char.typed {
  color: white;
}
.vue-typer .custom.caret {
  width: 3px;
  background-color: white;
} */

/* main1-2 */
#menu-section {
  height: 730px;
  padding: 40px 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #eeedec;
}
#menu-section .main-menus {
  display: flex;
  margin-top: 40px;
  align-items: center;
  justify-content: space-between;
}
#menu-section .main-menu {
  position: relative;
  padding: 10px 0px;
  cursor: pointer;
}
#menu-section .main-menu img {
  position: absolute;
  bottom: 0;
  right: 0;
  max-height: 90%;
  max-width: 90%;
  width: auto;
  height: auto;
  -webkit-transition: bottom 0.5s;
  -moz-transition: bottom 0.5s;
  transition: bottom 0.5s;
}
#menu-section .main-menu:last-child {
  margin-right: 0px;
}

#menu-section .main-menus .spacer {
  content: "";
  margin: 0px 10px;
  min-width: 30px;
  background-image: url("../assets/images/main_menu_logo_74x74.png");
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: center;
  height: 300px;
  animation-name: move;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}
#menu-section .main-menu:last-child::after {
  content: none;
}

#menu-section .main-menu:hover img {
  bottom: 10px;
}
#menu-section .en-name {
  text-transform: uppercase;
  font-size: 35px;
  padding-bottom: 20px;
  padding-top: 30px;
  letter-spacing: 0px;
  line-height: 90%;
  margin: 0;
  border-bottom: 3px solid #686059;
  font-family: "GothicAXHand-Regular", sans-serif;
}
#menu-section .ko-name {
  font-size: 20px;
  font-weight: 900;
  padding: 20px 0;
  margin: 0;
  line-height: 23px;
}
#menu-section .ko-name::after {
  content: "";
  background-image: url("../assets/images/Main_right_arrow.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin-top: 10px;
  width: 15px;
  height: 20px;
  display: block;
}
#menu-section .push-menu {
  margin-top: 40px;
  display: flex;
  align-items: flex-end;
}
#menu-section .push-menu p {
  font-size: 20px;
  margin-right: 60px;
  margin-bottom: 20px;
  font-weight: 900;
}
#menu-section .push-menu img.recommendedMenu {
  margin-right: 30px;
  animation: rockit 0.8s ease infinite alternate;
}
@keyframes rockit {
  from {
    transform: translatey(30px) rotate(-5deg);
  }
  to {
    transform: translatey(30px) rotate(5deg);
  }
}
#menu-section .push-menu .menu-name {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
/* main1-3 */
#store-section {
  height: 730px;
  /* max-width: 1500px; */
  padding-top: 40px;
  margin: auto;
  width: 100%;
  background-repeat: repeat;
  background-image: url("/images/store-cover.jpg");
  /* background-repeat: no-repeat; */
  /* background-position: left top 1300px; */
  background-size: auto;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
}
#store-section .section-contents {
  color: #ffffff;
}
#store-section .section-content {
  display: flex;
  /* background-color: powderblue; */
}
#store-section .store-CS {
  /* max-width: 380px; */
}
#store-section .store-count {
  display: flex;
  margin: 80px 0;
  justify-content: space-between;
  align-items: flex-start;
}
#store-section .store-count .land {
  flex: 1 1 30px;
}
#store-section .store-count .land p {
  margin-top: 20px;
  padding: 10px 0;
  border-bottom: 3px solid #ffffff;
}
#store-section .store-count .description {
  flex: 1 1 200px;
}
#store-section .store-count .description p {
  margin-top: 20px;
  padding: 10px 0;
  margin-bottom: 10px;
  border-bottom: 3px solid #ffffff;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: 20px;
  min-width: 30px;
  /* height: 300px; */
  box-sizing: border-box;
  /* display: flex;
  align-items: flex-end; */
  /* border: 1px solid black; */
}
#store-section .store-count .description span {
  display: block;
  margin-top: 10px;
  /* width: 70px;
  height: 70px; */
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: 25px;
}
#store-section .store-count .count {
  flex: 1 1 70px;
  font-family: "europa";
  font-weight: 700;
  font-size: 80px;
  min-width: 100px;
  margin: 0 10px;
  text-align: center;
}
#store-section .store-slider {
  margin-top: 60px;
  display: none;
}
#store-section .store-slider > p {
  font-size: 18px;
}
#store-section .store-slider .slider {
  margin-top: 10px;
  display: flex;
}
/* #store-section .store-slider .arrow {
  min-width: 15px;
  margin: 10px 0px;

} */
#store-section .store-slider .swiper-container .swiper-slide span {
  font-size: 16px;
}
#store-section .store-slider .arrow::after {
  content: "";
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 100%;
  width: 100%;
  display: block;
}
.arrow.left::after {
  background-image: url("../assets/images/Main_left_arrow.png");
}

.arrow.right::after {
  background-image: url("../assets/images/Main_right_arrow.png");
}

.arrow.left.dark::after {
  background-image: url("../assets/images/main_left_arrow_dark.png");
}

.arrow.right.dark::after {
  background-image: url("../assets/images/main_right_arrow_dark.png");
}

/* #store-section .store-slider .slider-content {
  min-width: 280px;
  max-width: 320px;
  height: 160px;
  padding: 20px;
} */
/* #store-section .store-slider img {
  width: 100%;
  margin-bottom: 20px;
} */

#store-section .store-mapchart {
  /* max-width: 380px; */
  height: 500px;
  /* flex-basis: 400px; */
  /* padding-left: 40px; */
  position: relative;
  /* border: 2px solid red; */
  /* background-color: tomato; */
}
#store-section .store-mapchart .map-info {
  /* position: absolute;
  top: 80px; */
  color: #d5c0af;
}

#store-section .map-info {
  pointer-events: none;
  z-index: 100;
  width: 110px;
  height: 30px;
  /* border: 2px solid red; */
  /* background-color: black;
  background-repeat: no-repeat;
  background-image: url('../assets/images/map-info-line.svg');
  background-size: 115px auto;
  background-position: 0px 10px; */
  position: absolute;

  /* display: none; */
  opacity: 0;
}
#store-section .map-info.right {
  top: 0px;
  left: 110px;
  margin-left: 27px;
  /* background-color: black; */
  transform: scaleX(-1);
  background-position: 0px 80px;
  /* display: block; */
  /* display: none; */
}
#store-section .map-info p {
  position: absolute;
  bottom: -10px;
  width: 100%;
  font-family: "europa";
  font-weight: 600;
  font-size: 18px;

  /* border: 1px solid powderblue; */
  /* border-bottom: 2px solid#d5c0af;
  border-radius: 0 0 30px 0 / 0 0 30px 0; */
  /* background-image: url("../assets/images/map-info-line-landing.svg"); */
  background-size: 115px auto;
  background-position-y: 90%;
  background-repeat: no-repeat;
}
#store-section .map-info.right p {
  /* margin-left: 100px; */
  text-align: right;
  transform: scaleX(-1);
  /* background-image: url("../assets/images/map-info-line-right-landing.svg"); */
  background-size: 115px auto;
  background-position-y: 100%;
  background-repeat: no-repeat;
  /* border-bottom: 2px solid#d5c0af; */
}
#store-section .map-info h3 {
  /* border-top: 2px solid #d5c0af; */
  margin-top: 45px;
}

.map-on > div.map-info {
  opacity: 1 !important;
}
.map-on > div.icon {
  opacity: 1 !important;
  background-image: url("../assets/images/store_map_active1.svg") !important;
}

div:not(.disable).icon {
  animation-name: move;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}
@keyframes move {
  /* keyframe */
  0% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.3);
  }
}

#store-section .map-info.right h3 {
  text-align: right;
  transform: scaleX(-1);
  /* border-bottom: 2px solid#d5c0af; */
}
#store-section .store-mapchart p span {
  font-size: 60px;
  margin-right: 10px;
}

#store-section .store-mapchart .map {
  margin: 0px auto;
  width: 280px;
  height: 100%;
  position: relative;
  background-image: url("../assets/images/map-background.png");
  background-size: contain;
  background-repeat: no-repeat;
  /* border: 2px solid white; */
}

#store-section .store-mapchart div.wrap {
  width: 30px;
  height: 30px;
  position: absolute;
  /* border: 3px solid blue; */
}

#store-section .store-mapchart .icon {
  /* border: 1px solid green; */
  width: 30px;
  height: 30px;
  background-image: url("../assets/images/store-map-default.svg");
  background-size: contain;
  left: 110px;
  position: absolute;
  transition: all 0.5s;
}

#store-section .store-mapchart .icon.disable {
  /* border: 1px solid green; */
  background-image: url("../assets/images/store-map-disable.svg");
  background-size: contain;
  left: 110px;
  position: absolute;
}

#store-section .store-mapchart div.wrap .icon:not(.disable):hover {
  transition: all 0.3s ease-in;
  width: 30px;
  height: 30px;
  background-image: url("../assets/images/store_map_active1.svg");
  background-size: contain;
  left: 110px;
  position: absolute;
  transform: scale(1.3);
}

/* #store-section .store-mapchart div.wrap .icon.disable:hover {
  width: 30px;
  height: 30px;
  background-image: url("../assets/images/map-icon-disable.svg");
  background-size: contain;
  left: 110px;
  position: absolute;
} */

#store-section .store-mapchart div.wrap .icon:hover + .map-info {
  opacity: 1;
  transition: all 0.3s ease-in;
}

#store-section .store-inputs {
  margin: 80px 0;
  display: flex;
  flex-wrap: wrap;
  height: max-content;
  flex-direction: column;
  /* background-color: tomato; */
}
#store-section .store-inputs > div {
  display: flex;
  margin-bottom: 10px;
}
#store-section .store-inputs p {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

#store-section .store-inputs select,
#store-section .store-inputs input {
  border: 0;
}
#store-section .store-inputs input {
  flex: 1;
  margin-right: 5px;
}
#store-section .store-inputs div.v-input {
  margin: 4px 6px 0px 0px;
}
#store-section .store-inputs button {
  padding: 0px 15px;
  border: 0;
  background-color: #ffffff;
  height: 50px;
  width: 110px;
}
#store-section img.search-btn {
  cursor: pointer;
  transform: scale(1.3);
  transition: all 1s;
}

.detailBtn {
  text-decoration: none;
  color: #4d4d4d;
  border-top: 3px solid #686059;
  padding: 5px 0;
  display: block;
  float: right;
  font-weight: 700;
}
.detailBtn.txt-white {
  color: #ffffff;
  border-color: #ffffff;
}

#community-section {
  height: 400px;
  /* max-width: 1500px; */
  padding-top: 40px;
  margin: auto;
  width: 100%;
  background-color: #686059;
  display: flex;
  justify-content: center;
  color: white;
  /* background-image: url("../assets/images/landing-community-figure.png"); */
  background-position: bottom;
  background-size: 40% auto;
}
#community-section .section-content {
  margin-top: 120px;
  display: flex;
  justify-content: space-between;
  /* background-color: powderblue; */
}
#community-section .column {
  display: flex;
  flex-direction: column;
  /* background-color: tomato; */
}
#community-section .subtitle {
}

#community-section .subtitle p {
  text-align: center;
}
#community-section .news .news-title {
  margin-top: -17px;
  border-bottom: 3px solid white;
  font-size: 32pt;
  font-family: "europa";
  font-weight: 600;
}

#community-section .news .row > a {
  display: flex;
  justify-content: space-between;
  margin: 10px 0px;
  font-weight: 400;
  font-size: 14px;
}
#community-section .news .row {
  padding: 0px 5px;
  transition: all 0.4s;
}
#community-section .news .row:hover {
  background-color: #ccc;
  color: #333;
}
#community-section .news .row:hover > a {
  font-weight: 600;
}

#community-section .news .footer {
  border-top: 2px solid white;
  padding-top: 20px;
  font-weight: 600;
  font-size: 16px;
}

/* #community-section div.call {
  background-image: url("../assets/images/franchise-background.png");
  background-size: auto 320px;
  background-repeat: no-repeat;
  background-position: 10px -25px;
  border: 2px solid red;
  padding-left: 90px;
  padding-top: 40px;
} */
#community-section .call h2 {
  font-weight: 600;
  font-size: 18px;
}
#community-section .call span {
  padding: 10px 0px;
  font-weight: 600;
  font-size: 40px;
  font-family: "europa";
  color: white;
  /* color: #d5c0af; */
}
#community-section .call p {
  color: black;
  font-size: 14px;
  line-height: 18px;
}
#community-section .call .sms {
  margin-top: 40px;
}
#community-section .event .mobile {
  display: flex;
  justify-content: flex-start;
  padding: 20px 0px;
}

input.number {
  display: block;
  width: 80px; /* 원하는 너비 설정 */
  height: auto; /* 높이값 초기화 */
  line-height: normal; /* line-height 초기화 */
  padding: 0; /* 원하는 여백 설정, 상하단 여백으로 높이를 조절 */
  font-family: "europa";
  font-weight: 400;
  font-size: 30px;
  color: white;
  border: 0px solid #999;
  border-radius: 0; /* iSO 둥근모서리 제거 */
  outline-style: none; /* 포커스시 발생하는 효과 제거를 원한다면 */
  -webkit-appearance: none; /* 브라우저별 기본 스타일링 제거 */
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border-bottom: 3px solid white;
  margin: 0px 20px 0px 0px;
}
input.number:after {
  display: inline-table;
  content: "-";
  margin: 0px 10px;
  font-size: 15px;
}

#community-section .call .sms h2 span {
  color: white;
}
#community-section .event {
  position: relative;
}
#community-section .event p {
  margin: 20px 0px;
  width: 200px;
  font-size: 14px;
  line-height: 18px;
}
#community-section .event img {
  position: absolute;
  padding-bottom: 40px;
  bottom: 0;
  right: 0;
  max-height: 80%;
  max-width: 80%;
  width: auto;
  height: auto;
  -webkit-transition: bottom 0.5s;
  -moz-transition: bottom 0.5s;
  transition: bottom 0.5s;
}
#community-section .event:hover img {
  bottom: 10px;
}

/* control */
.flex-1 {
  height: 50px;
  /* background-color: tomato; */
}

/*==================== media ====================*/
/*==================== media ====================*/
/*==================== media ====================*/
/*==================== media ====================*/
@media (max-width: 1023px) {
  #banner div.swiper-container {
    /* height: 500px; */
  }

  .mobile-none {
    display: none !important;
  }
  #slider-container {
    height: 500px;
    background-color: rgba(104, 96, 89, 0.7);
  }
  #slider-container section {
    height: 500px;
  }
  #brand-section {
    height: 500px;
    max-width: 100vw;
  }

  div.section-cover {
    padding: 0px 0px;
    padding-bottom: 40px;
    /* padding: 0px 0px 200px 0px; */
    justify-content: flex-end;
    align-items: center;
    height: 500px;
    /* max-width: 1500px; */
    background-repeat: no-repeat;
    /* background-size: cover; */
    /* background-position: center 80px; */
  }

  div.section-contents {
    padding: 20px;
    min-width: 320px;
    overflow: hidden;
  }
  div.header-space {
    height: 80px;
  }

  #brand-section .section-cover {
    background: linear-gradient(
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0) 60%,
        rgba(104, 96, 89, 1) 80%,
        rgba(104, 96, 89, 1)
      ),
      url("/images/main_cover_full.jpg");
    background-position-x: center, center;
    background-size: 100%, auto 500px;
    background-repeat: no-repeat;
  }
  #salt-section .section-cover {
    background: linear-gradient(
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0) 60%,
        rgba(104, 96, 89, 1) 80%,
        rgba(104, 96, 89, 1)
      ),
      url("/images/main-cover-full-alt.jpg");
    background-position-x: center, center;
    background-size: 100%, auto 500px;
    background-repeat: no-repeat;
  }
  #brand-section ul.menu {
    flex: 0;
    padding-top: 0px;
  }
  #brand-section .main-copy .line {
    display: none;
  }
  #slider-container .main-copy {
    flex: 0;
    min-height: 70px;
    margin-top: 10px;
  }
  #brand-section .menu li {
    display: inline-block;
    text-align: center;
    font-weight: 700;
    font-size: 12px;
    margin: 0px 0px;
  }
  #brand-section .menu li:before {
    display: inline-table;
    content: "|";
    margin-right: 5px;
    font-size: 5px;
  }
  #brand-section .menu li:first-child::before {
    content: "";
  }
  #brand-section .main-copy h1 {
    min-width: 320px;
    max-width: 340px;
    flex: 0;
    font-size: 57px;
    letter-spacing: -2px;
  }

  #slider-container div.main-desc {
    margin-top: 40px;
    min-height: 100px;
    flex: 0;
    width: 100vw;
    transform: initial;
  }
  #slider-container .main-desc > div {
    flex: 0;
  }
  #slider-container .main-desc > div.content {
    min-width: 320px;
    width: 100vw;
  }
  #slider-container .main-desc .desc {
    /* max-width: 430px; */
    /* background-color: powderblue; */
    /* margin: -30px auto; */
    text-align: center;
    font-weight: 400;
    line-height: 22px;
    font-size: 15px;
    letter-spacing: -1px;
    /* padding-left: 500px; */
  }
  #salt-section .main-copy h1 {
    min-width: 320px;
    max-width: 340px;
    flex: 0;
    font-size: 65px;
    letter-spacing: -1px;
  }

  #menu-section {
    padding: 0px;
    height: auto;
  }
  .flex-contents {
    min-width: 140px;
    flex: 1;
  }
  h2.main-title {
    margin-top: -12px !important;
    font-size: 40px !important;
    min-width: 140px !important;
  }
  h2.main-title span {
    font-size: 13px !important;
    padding-left: 2px;
    margin-top: 5px !important;
  }
  .subtitle p {
    font-size: 12px !important;
    min-width: 180px !important;
    line-height: 16px !important;
  }
  .spacer,
  .flex-1,
  .push-menu {
    display: none !important;
  }

  div.section-content.main-menus {
    flex-direction: column;
    align-items: flex-start !important;
  }
  div.main-menu {
    margin-bottom: 20px;
    min-width: 100% !important;
    max-height: 200px;
  }
  div.main-menu .en-name {
    font-size: 30px !important;
    padding-bottom: 10px !important;
  }

  div.main-menu .ko-name {
    font-size: 16px !important;
    padding: 10px 0px !important;
  }

  #store-section {
    background-position: 70%;
    padding-top: 0px;
    background-repeat: initial;
    background-attachment: scroll;
  }
  #store-section .section-content {
    flex-direction: column;
    margin-top: 20px;
  }
  #store-section .store-count .description p {
    font-size: 12px;
  }
  #store-section .store-CS .description span {
    font-size: 12px;
    word-break: keep-all;
  }
  #store-section .store-count {
    margin: 10px 0px;
  }
  #store-section .store-count .land p {
    min-width: 30px;
    font-size: 12px;
  }
  #store-section .store-count .count {
    font-size: 80px;
    margin: 0px;
  }
  #store-section .store-inputs,
  .store-slider {
    display: none !important;
  }
  #community-section {
    padding: 0px;
    height: 500px;
    background-size: contain;
  }
  #community-section .section-title {
    flex-direction: column;
  }
  #community-section .section-title h2.main-title {
    margin: 0px;
  }
  #community-section .subtitle {
    margin-top: 15px;
    width: 100%;
  }
  #community-section .subtitle p {
    text-align: right;
  }
  #community-section div.news {
    margin-top: 40px;
    width: 100% !important;
    max-width: initial;
  }
  #community-section div.news > div.news-title > h3 {
    font-size: 28px;
  }
  #community-section div.news > div.body .row span {
    font-size: 12px;
  }
}
</style>
